import { LinkButton, type LinkButtonProps } from '../buttons/index.ts'

export const FeedLinkButton = ({ children, ...props }: LinkButtonProps) => {
  return (
    <LinkButton size="sm" {...props}>
      {children}
    </LinkButton>
  )
}
